import { render, staticRenderFns } from "./UserUpdateLattes.vue?vue&type=template&id=03bd3fa8&scoped=true&"
import script from "./UserUpdateLattes.vue?vue&type=script&lang=js&"
export * from "./UserUpdateLattes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bd3fa8",
  null
  
)

export default component.exports